import type { McpCallToolRequestPayload } from '../types/mcpNode';
import { IGetOneResponse } from '../util/Types/Generic';
import { ApiService } from './ApiService';

export interface McpToolItem {
  name: string;
  title?: string;
  description?: string;
  inputSchema?: Record<string, unknown>;
}

export interface McpListToolsResponse {
  tools: McpToolItem[];
}

export class McpServerService extends ApiService {
  static pathName = '/mcp_call';

  static request(
    body: McpCallToolRequestPayload,
  ): Promise<IGetOneResponse<string>> {
    return this.post(`${this.pathName}`, body);
  }

  static listTools(body: {
    serverUrl?: string;
    authToken?: string;
    integrationId?: string;
    organizationId?: string;
    sessionId?: string;
    protocolVersion?: string;
  }): Promise<IGetOneResponse<McpListToolsResponse>> {
    return this.post<IGetOneResponse<McpListToolsResponse>>(
      `${this.pathName}/list-tools`,
      body,
    );
  }

  static getOAuthAuthorizeUrl(params: {
    provider: string;
    scopeType: 'user' | 'organization';
    organizationId: string;
    mcpServerUrl?: string;
  }): Promise<IGetOneResponse<{ authorizeUrl: string; state: string }>> {
    const q = new URLSearchParams({
      provider: params.provider,
      scopeType: params.scopeType,
      organizationId: params.organizationId,
    });
    if (params.mcpServerUrl?.trim()) {
      q.set('mcpServerUrl', params.mcpServerUrl.trim());
    }
    return this.get(
      `${this.pathName}/oauth/authorize?${q.toString()}`,
    ) as Promise<IGetOneResponse<{ authorizeUrl: string; state: string }>>;
  }
}
